import Stack from 'src/app/atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const HelpCircleHintContainer = styled(Stack)`
  .tooltip-text {
    max-width: 70vw;
    width: 250px;
    margin: 0;
  }

  .tooltip-anchor {
    display: flex;
  }
`;
